import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

document.querySelectorAll('.three-card--swiper').forEach((el) => {
  const swiper = new Swiper(el, {
    modules: [Autoplay],
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 16,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    grabCursor: true,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });

  el.parentElement.querySelectorAll('.three-card--next').forEach((btn) => {
    btn.addEventListener('click', () => swiper.slideNext());
  });
});
